<template>
    <v-row no-gutters>
        <v-col>
            <v-toolbar dense :elevation="0" >
                <div class="text-primary-700" style="font-weight: 700; display: grid;">
                    <span style="font-size: large">Pipelines</span>  
                    <span style="margin-top:-10px">
                        <a href="https://rp-database.com/docs/features/enquiries" target="_blank" rel="noopener noreferrer" class="title-docs" style="font-size: small;">Open Docs</a>
                    </span>
                </div>
                <v-btn-toggle class="mx-2"
                    v-model="tableType"
                    tile
                    group
                    mandatory
                >
                    <v-btn value="pipeline">
                        By Pipeline
                    </v-btn>

                    <v-btn value="property">
                        By Property
                    </v-btn>
                </v-btn-toggle>
                <v-spacer></v-spacer>
                <template v-if="tableType === 'pipeline'">
                    <v-menu
                        :close-on-content-click="false"
                        :nudge-width="300"
                        offset-y>
                        <template v-slot:activator="{ on }">
                            <v-badge class="mr-4" color="red" style="float:right" overlap bordered :value="filtersActive">
                                <v-btn outlined v-on="on" class="mt-0">
                                    <v-icon>mdi-table-search</v-icon> 
                                    Filters
                                </v-btn>
                            </v-badge>
                        </template>

                        <v-card>
                            <v-card-title>
                            <h4 class="text-primary-700">Filters</h4>
                            <v-spacer></v-spacer>
                            <v-btn class="ml-2" outlined @click="resetFilters">
                                Reset
                            </v-btn>
                            </v-card-title>
                            <v-divider class="mx-2"></v-divider>
                            <v-card-text class="rpd-filter-card-text">
                                <v-text-field
                                    v-model="filters.search"
                                    label="Search"
                                    outlined dense
                                    clearable
                                ></v-text-field>
                                <v-autocomplete
                                    
                                    v-model="filters.pipeline"
                                    :loading="pipeline.loading"
                                    :items="pipeline.items"
                                    :search-input.sync="pipeline.search"
                                    :item-text="'name'"
                                    :hide-no-data="pipeline.loading ? true : false"
                                    :menu-props="{
                                        offsetY: true,
                                    }"
                                    return-object
                                    required
                                    clearable
                                    outlined dense
                                    label="Pipeline"
                                ></v-autocomplete>
                                <v-autocomplete
                                    v-model="filters.client"
                                    :search-input.sync="client.search"
                                    :items="client.items"
                                    :loading="client.loading"
                                    :item-title="item => item.label"
                                    :item-value="item => item.value"
                                    :item-text="'label'"
                                    label="Client"
                                    clearable
                                    return-object
                                    outlined dense
                                    hide-no-data
                                ></v-autocomplete>
                                <v-autocomplete
                                    v-model="filters.contact"
                                    :search-input.sync="contact.search"
                                    :items="contact.items" 
                                    :loading="contact.loading"
                                    :item-title="item => item.label"
                                    :item-value="item => item.value"
                                    :item-text="'label'"
                                    label="Contact"
                                    clearable
                                    return-object
                                    outlined dense
                                    hide-no-data
                                ></v-autocomplete>
                            </v-card-text>
                        </v-card>
                    </v-menu> 
                    <v-btn @click="createPipeline" color="primary float-right" outlined>New Pipeline</v-btn>
                </template>
                <template v-else>
                    <v-checkbox
                        v-model="hideWithdrawn"
                        label="Hide Withdrawn/Completed"
                        :disabled="disableWithdrawn"
                        hide-details
                        class="mr-4"
                    ></v-checkbox>
                    <v-menu
                        :close-on-content-click="false"
                        :nudge-width="300"
                        offset-y>
                        <template v-slot:activator="{ on }">
                            <v-badge class="mr-4" color="red" style="float:right" overlap bordered :value="filtersActive">
                                <v-btn outlined v-on="on" class="mt-0">
                                    <v-icon>mdi-table-search</v-icon> 
                                    Filters
                                </v-btn>
                            </v-badge>
                        </template>

                        <v-card>
                            <v-card-title>
                            <h4 class="text-primary-700">Filters</h4>
                            <v-spacer></v-spacer>
                            <v-btn class="ml-2" outlined @click="resetFilters">
                                Reset
                            </v-btn>
                            </v-card-title>
                            <v-divider class="mx-2"></v-divider>
                            <v-card-text class="rpd-filter-card-text">
                                <v-autocomplete
                                    
                                    v-model="filters.pipeline"
                                    :loading="pipeline.loading"
                                    :items="pipeline.items"
                                    :search-input.sync="pipeline.search"
                                    :item-text="'name'"
                                    :hide-no-data="pipeline.loading ? true : false"
                                    :menu-props="{
                                        offsetY: true,
                                    }"
                                    return-object
                                    required
                                    clearable
                                    outlined dense
                                    label="Pipeline"
                                ></v-autocomplete>
                                <v-select
                                    v-model="filters.status"
                                    :items="statusOptions"
                                    :menu-props="{offsetY: true}"
                                    label="Status"
                                    clearable
                                    outlined dense
                                ></v-select>
                                <v-select
                                    v-model="filters.reason"
                                    :items="reasonOptions"
                                    :menu-props="{offsetY: true,}"
                                    label="Reason"
                                    clearable   
                                    outlined dense
                                ></v-select>
                            </v-card-text>
                        </v-card>
                    </v-menu> 

                        
                    <v-btn @click="addPipelineProperty(null, 'property')" color="primary float-right" outlined>Add Property</v-btn>
                </template>

            </v-toolbar>
            <v-card-text>
                <v-data-table
                    style="width:100%; border: 1px solid #e0e0e0; border-radius: 4px;"
                    :headers="tableType === 'pipeline' ? pipelineHeaders : propertyHeaders"
                    :items="tableType === 'pipeline' ? pipelines : properties"
                    :search="ts.search"
                    :loading="loading"
                    :options.sync="ts.pagination"
                    :server-items-length="ts.totalRecords"
                    :items-per-page.sync="ts.itemsPerPage"
                    :page.sync="ts.page"
                    :loading-text="'Loading... Please wait.'"
                    :sort-by.sync="ts.sortBy"
                    :sort-desc.sync="ts.sortDesc"
                    :multi-sort="false"
                    :footer-props="{'items-per-page-options': [50, 100, 500],}"
                    class="elevation-0"
                >

                    <template v-slot:body="{ items }">
                        <tbody v-if="initLoader">
                            <tr v-for="n in 12" :key="n">
                                <td class="px-0 table-loading" :colspan="tableType === 'pipeline' ? pipelineHeaders.length : propertyHeaders.length">
                                    <v-skeleton-loader
                                    type="list-item"
                                    ></v-skeleton-loader>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else-if="items.length > 0">
                            <template v-if="tableType === 'pipeline'">
                                <tr v-for="item in items">
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.client.data.name }}</td>
                                    <td>{{ item.contact.data.name }}</td>
                                    <td class="text-center">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn class="mx-1" icon small @click="addPipelineProperty(item)" v-on="on">
                                                    <v-icon small>mdi-plus</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Add property to pipeline</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn class="mx-1" icon small @click="viewPipeline(item)" v-on="on">
                                                    <v-icon small>mdi-eye</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>View pipeline properties</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn class="mx-1" icon small @click="editPipeline(item)" v-on="on">
                                                    <v-icon small>mdi-pencil</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Edit pipeline</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn class="mx-1" icon small @click="deletePipeline(item)" v-on="on">
                                                    <v-icon small>mdi-delete</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Delete pipeline</span>
                                        </v-tooltip>
                                    </td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr v-for="item in items">
                                    <td>{{ item.pipeline.data.name }}</td>
                                    <td>
                                        <a v-if="item.property_id" @click="viewProperty(item.property_id)">
                                            {{ item.property.data.address.data.full_address }}
                                        </a>
                                    </td>
                                    <td>
                                        <a v-if="item.property.data.scheme_id" @click="viewScheme(item.property.data.scheme_id)">
                                            {{ item.property.data.scheme.data.name }}
                                        </a>
                                    </td>
                                    <td>{{ formatStatus(item.status) }}</td>
                                    <td>{{ formatReason(item.reason) }}</td>
                                    <td class="text-center">
                                        <v-btn class="mx-1" icon small @click="editPipelineProperty(item)">
                                            <v-icon small>mdi-pencil</v-icon>
                                        </v-btn>
                                        <v-btn class="mx-1" icon small @click="deletePipelineProperty(item)">
                                            <v-icon small>mdi-delete</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                                
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td :colspan="tableType === 'pipeline' ? pipelineHeaders.length : propertyHeaders.length" class="text-center">No records found</td>
                            </tr>
                        </tbody>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-col>
        <create-pipeline ref="createPipeline" @created="fetchData"></create-pipeline>
        <edit-pipeline ref="editPipeline" @edited="fetchData"></edit-pipeline>
        <add-pipeline-property ref="addPipelineProperty" @added="fetchData"></add-pipeline-property>
        <edit-pipeline-property ref="editPipelineProperty" @edited="fetchData"></edit-pipeline-property>
        <edit-property-dialog ref="editPropertyDialog" @updated="fetchData"></edit-property-dialog>
        <edit-scheme-dialog ref="editSchemeDialog"></edit-scheme-dialog>

    </v-row>
</template>
<script>
    import createPipeline from '@/pages/pipeline/createPipeline.vue';
    import editPipeline from '@/pages/pipeline/editPipeline.vue';
    import EditPropertyDialog from "@/components/properties/editPropertyDialog";
    import EditSchemeDialog from '@/components/schemes/editSchemeDialog'
    import addPipelineProperty from '@/pages/pipeline/addPipelineProperty.vue';
    import editPipelineProperty from '@/pages/pipeline/editPipelineProperty.vue';
import { filter } from 'lodash';
    export default {
        components: {
            createPipeline,
            editPipeline,
            addPipelineProperty,
            editPipelineProperty,
            EditPropertyDialog,
            EditSchemeDialog
        },
        data() {
            return {
                pipelineHeaders: [
                    { text: 'Pipeline', value: 'name', class:'data-table__cell'},
                    { text: 'Client', value: 'client.data.name', class:'data-table__cell'},
                    { text: 'Contact', value: 'contact.data.name', class:'data-table__cell'},
                    { text: 'Actions', value: 'actions', sortable: false, align: 'center', width: '200px' },
                ],
                propertyHeaders: [
                    { text: 'Pipeline', value: 'pipeline.data.name', class:'data-table__cell'},
                    { text: 'Property', value: 'property.data.address.data.full_address', class:'data-table__cell'},
                    { text: 'Scheme', value: 'property.data.scheme.data.name', class:'data-table__cell'},
                    { text: 'Status', value: 'status', class:'data-table__cell'},
                    { text: 'Reason', value: 'reason', class:'data-table__cell'},
                    { text: 'Actions', value: 'actions', sortable: false, align: 'center', width: '125px' },
                ],
                ts:{
                    search: '',
                    page: 1,
                    itemsPerPage: 50,
                    totalRecords: 0,
                    pagination: {},
                    initLoader: true,
                    sortBy: 'name',
                    sortDesc: false,
                },

                filters: {
                    pipeline: null,
                    search: '',
                    client: null,
                    contact: null,
                    status: '',
                    reason: '',
                },

                statusOptions: [
                    { value: 'tbi', text: 'To Be Inspected'},
                    { value: 'offer-submitted', text: 'Offer Submitted/Negotiating'},
                    { value: 'with-solicitors', text: 'With Solicitors'},
                    { value: 'exchanged', text: 'Exchanged'},
                    { value: 'completed', text: 'Completed'},
                    { value: 'withdrawn', text: 'Withdrawn'},
                ],

                // reason options; new store, upsize, downsize, relocation, disposal/closure
                reasonOptions: [
                    { value: 'new-store', text: 'New Store'},
                    { value: 'upsize', text: 'Upsize'},
                    { value: 'downsize', text: 'Downsize'},
                    { value: 'relocation', text: 'Relocation'},
                    { value: 'disposal-closure', text: 'Disposal/Closure'},
                    { value: 'price', text: 'Price'},
                    { value: 'location', text: 'Location'},
                    { value: 'too-big', text: 'Too Big'},
                    { value: 'too-small', text: 'Too Small'},
                    { value: 'tenant-mix', text: 'Tenant Mix'},
                    { value: 'access', text: 'Access'},
                    { value: 'other', text: 'Other'},
                ],

                pipelines: [],
                properties: [],
                tableType: 'pipeline',
                hideWithdrawn: false,

                contact: {
                    items: [],
                    loading: false,
                    search: null,
                },
                client: {
                    items: [],
                    loading: false,
                    search: null,
                },
                pipeline: {
                    items: [],
                    loading: false,
                    search: null,
                },

                loading: false,
                initLoader: true,
            };
        },
        methods: {
            fetchData() {
                this.loading = true;
                if (this.tableType === 'pipeline') {
                    this.fetchPipelines();
                } else {
                    this.fetchProperties();
                }
            },

            fetchPipelines() {
                this.$http.get('/pipelines', {
                    params: {
                        include: 'client,contact,property,scheme,area,status,reason',
                        search: this.filters.search,
                        pipeline_id: this.filters.pipeline ? this.filters.pipeline.id : null,
                        client_id: this.filters.client ? this.filters.client.value : null,
                        contact_id: this.filters.contact ? this.filters.contact.value : null,
                    }
                }).then(response => {
                    this.pipelines = response.data.data;
                    this.ts.totalRecords = response.data.total;
                    this.ts.pagination = response.data.pagination;
                    this.loading = false;
                    this.initLoader = false;
                }).catch(error => {
                    this.loading = false;
                    this.initLoader = false;
                })
            },

            fetchProperties() {
                this.$http.get('/pipeline-items', {
                    params: {
                        include: 'pipeline,property,property.address,property.scheme,scheme,area,status,reason',
                        page: this.page,
                        itemsPerPage: this.itemsPerPage,
                        pipeline_id: this.filters.pipeline ? this.filters.pipeline.id : null,
                        status: this.filters.status ? this.filters.status : this.hideWithdrawn ? ['tbi', 'offer-submitted', 'with-solicitors', 'exchanged'] : null,
                        reason: this.filters.reason,
                    }
                }).then(response => {
                    this.properties = response.data.data;
                    this.ts.totalRecords = response.data.total;
                    this.ts.pagination = response.data.pagination;
                    this.loading = false;
                    this.initLoader = false;
                }).catch(error => {
                    this.loading = false;
                    this.initLoader = false;
                })
            },

            async filterPipelines() {
                this.$http.get("/pipelines",{
                }).then(response => {
                    this.pipeline.items = response.data.data
                    this.pipeline.loading = false
                }).catch(error => {
                    console.log(error)
                    this.pipeline.loading = false
                })
            },

            async getCompanies(prop){
                this.$http.get("/companies",{
                    params: {
                        q: prop,
                        per_page: 50,
                    }
                }).then(response => {
                    this.client.items = response.data.data.map(company => {
                        return {
                            value: company.id,
                            label: company.name,
                        }
                    })
                    this.client.loading = false
                }).catch(error => {
                    this.client.loading = false
                })
            },

            async getContacts(prop){
                this.$http.get("/users",{
                    params: {
                        q: prop,
                        per_page: 50,
                    }
                }).then(response => {
                    this.contact.items = response.data.data.map(contact => {
                        return {
                        value: contact.id,
                        label: contact.name,
                        }
                    })
                    this.contact.loading = false
                }).catch(error => {
                    this.contact.loading = false
                })
            },

            createPipeline() {
                this.$refs.createPipeline.openDialog();
            },

            editPipeline(entity) {
                this.$refs.editPipeline.openDialog(entity);
            },

            addPipelineProperty(entity, type = 'pipeline') {
                this.$refs.addPipelineProperty.openDialog(entity, type);
            },

            editPipelineProperty(entity) {
                this.$refs.editPipelineProperty.openDialog(entity);
            },

            viewPipeline(entity) {
                // swap to properties tab and filter by pipeline
                this.tableType = 'property';
                this.filters.pipeline = entity;
            },

            deletePipeline(entity) {
                this.$notify.question(`Are you sure you want to delete ${entity.name}`, () => {
                    this.$http.delete(`/pipelines/${entity.id}`)
                    .then(response => {
                        this.fetchData();
                    })
                    .catch(error => {
                        console.log(error)
                    })
                })
            },

            deletePipelineProperty(entity) {
                this.$notify.question(`Are you sure you want to delete ${entity.property.data.address.data.full_address}`, () => {
                    this.$http.delete(`/pipelines/${entity.pipeline_id}/items/${entity.id}`)
                    .then(response => {
                        this.fetchData();
                    })
                    .catch(error => {
                        console.log(error)
                    })
                })
            },

            viewProperty(id) {
                this.$refs.editPropertyDialog.showDialog(id);
            },
            viewScheme(id) {
                this.$refs.editSchemeDialog.showDialog(id);
            },

            formatStatus(status) {
                if (!status) return '';
                return this.statusOptions.find(option => option.value === status).text;
            },
            formatReason(reason) {
                if (!reason) return '';
                return this.reasonOptions.find(option => option.value === reason).text;
            },

            resetFilters() {
                this.filters = {
                    pipeline: null,
                    search: '',
                    client: null,
                    contact: null,
                    status: '',
                    reason: '',
                }
            },
        },

        watch: {
            tableType() {
                // this.initLoader = true;
                this.fetchData();
                if(this.tableType === 'property') {
                    this.filterPipelines();
                }
            },
            filters: {
                handler() {
                    this.fetchData();
                },
                deep: true
            },
            'contact.search': function(val){
                if(!val) return
                this.contact.loading = true
                this.getContacts(val)
            },
            'client.search': function(val){
                if(!val) return
                this.client.loading = true
                this.getCompanies(val)
            },
            'hideWithdrawn': function(val){
                this.fetchData()
            }
        },
        computed: {
            disableWithdrawn() {
                if(this.filters.status){
                    return true
                }else{
                    return false
                }
            },
            filtersActive() {
                if(this.tableType === 'pipeline') {
                    if(this.filters.pipeline || this.filters.search || this.filters.client || this.filters.contact) {
                        return true
                    }else{
                        return false
                    }
                }else{
                    if(this.filters.pipeline || this.filters.status || this.filters.reason) {
                        return true
                    }else{
                        return false
                    }
                }
            }
        },

        mounted() {
            this.fetchData();
        },
    }
</script>